import { useQuery } from '@tanstack/react-query';
import { shopStaffApi } from '@/api/shopStaff';
import { useAuthStore } from '@/store/authStore';

export function shopStaffScope() {
  const state = useAuthStore.getState();
  return JSON.stringify([state.tenantId, state.impersonatedTenantId, state.providerId, state.user?.userId]);
}

export function useShopStaffAccess() {
  const { role, user, tenantId, impersonatedTenantId, providerId } = useAuthStore();
  const scope = JSON.stringify([tenantId, impersonatedTenantId, providerId, user?.userId]);
  const query = useQuery({ queryKey: ['shop-staff-access', scope], queryFn: shopStaffApi.access,
    enabled: (role === 'provideradmin' || role === 'providerstaff') && !!user, staleTime: 15_000, refetchOnWindowFocus: true,
    refetchInterval: current => current.state.data?.isStaffMember === true || current.state.data?.available && current.state.data.isOwner === false ? 30_000 : false });
  return { ...query, scope, isStaff: query.data?.isStaffMember === true || !!query.data?.available && query.data.isOwner === false };
}
